<app-coupons-filters (onFilter)="onFilter($event)" [defaultFilters]="defaultFilters">
</app-coupons-filters>

<mat-card class="add-button-container" *ngIf="!(coupons | async)?.length">
  <h4>Nessun coupon trovato</h4>
  <button class="add-button" *ngIf="canAdd" mat-raised-button (click)="addCoupon()" color="primary">
    Aggiungi
  </button>
</mat-card>

<div class="table-container" [hidden]="!(coupons | async)?.length">
  <table mat-table matSort [dataSource]="coupons" multiTemplateDataRows matSortDisableClear matSortActive="code"
    matSortDirection="asc">

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef> Codice </th>
      <td mat-cell *matCellDef="let element"> {{ element.code }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let element"> {{ element.name || 'N/A' }} </td>
    </ng-container>

    <ng-container matColumnDef="validFrom">
      <th mat-header-cell *matHeaderCellDef> Data Inizio </th>
      <td mat-cell *matCellDef="let element"> {{ element.startDate | date:'dd/MM/yyyy' }} </td>
    </ng-container>

    <ng-container matColumnDef="validTo">
      <th mat-header-cell *matHeaderCellDef> Data Fine </th>
      <td mat-cell *matCellDef="let element"> {{ element.endDate | date:'dd/MM/yyyy' }} </td>
    </ng-container>

    <ng-container matColumnDef="discountValue">
      <th mat-header-cell *matHeaderCellDef> Sconto </th>
      <td mat-cell *matCellDef="let element">
        {{ element.type === 'percentage' ? element.discount + '%' : element.discount + '€' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="minOrderAmount">
      <th mat-header-cell *matHeaderCellDef> Min. Importo</th>
      <td mat-cell *matCellDef="let element"> €{{ element.minimumOrderAmount }} </td>
    </ng-container>

    <ng-container matColumnDef="maxOrderAmount">
      <th mat-header-cell *matHeaderCellDef> Max. Importo </th>
      <td mat-cell *matCellDef="let element"> €{{ element.maximumOrderAmount }} </td>
    </ng-container>

    <ng-container matColumnDef="maxUsesPerUser">
      <th mat-header-cell *matHeaderCellDef> Max utilizzi per utente </th>
      <td mat-cell *matCellDef="let element"> {{ element.maxUsesPerUser }} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="add-icon-container">
        <button mat-mini-fab *ngIf="canAdd" matTooltip="Nuovo coupon"
          (click)="$event.stopPropagation(); addCoupon()" color="primary">
          <mat-icon>add</mat-icon>
        </button>
      </th>
      <td mat-cell *matCellDef="let row" class="modify-icon-container">
        <ng-container *ngIf="canEdit">
          <button mat-icon-button (click)="$event.stopPropagation(); editCoupon(row)">
            <mat-icon matTooltip="Modifica">create</mat-icon>
          </button>
        </ng-container>

        <button *ngIf="canSelect" mat-raised-button color="primary" (click)="selectCoupon(row)">
          Seleziona
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="editCoupon(row)"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="pageSizeOptions"
    [pageSize]="pageSizeOptions[0]"
    [length]="total | async">
  </mat-paginator>
</div>
